package meineglasfaser.frontend.www.pages.registrierung

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.PageContext
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.navigation.Anchor
import meineglasfaser.api.SurveyInstallationTypeWithOptions
import meineglasfaser.api.routes.ShopRoutes
import meineglasfaser.frontend.common.BackendApi
import meineglasfaser.frontend.common.components.widgets.Modal
import meineglasfaser.frontend.common.components.widgets.ModalCloseBtn
import meineglasfaser.frontend.common.components.widgets.ModalFooterButtons
import meineglasfaser.frontend.common.components.widgets.Toast
import meineglasfaser.frontend.common.components.widgets.Toasts
import meineglasfaser.frontend.common.components.widgets.UBLPostalAddressInputs
import meineglasfaser.frontend.common.components.widgets.rememberQuery
import meineglasfaser.frontend.common.components.yaform.YaForm
import meineglasfaser.frontend.common.components.yaform.YaFormCheckInput
import meineglasfaser.frontend.common.components.yaform.YaFormDropdown
import meineglasfaser.frontend.common.components.yaform.YaFormNumberInput
import meineglasfaser.frontend.common.components.yaform.YaFormTextInput
import meineglasfaser.frontend.common.setJsonBody
import org.jetbrains.compose.web.attributes.ATarget
import org.jetbrains.compose.web.attributes.InputType
import org.jetbrains.compose.web.attributes.target
import org.jetbrains.compose.web.dom.A
import org.jetbrains.compose.web.dom.Article
import org.jetbrains.compose.web.dom.Button
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.H1
import org.jetbrains.compose.web.dom.H3
import org.jetbrains.compose.web.dom.Header
import org.jetbrains.compose.web.dom.P
import org.jetbrains.compose.web.dom.Small
import org.jetbrains.compose.web.dom.Text

@Page
@Layout(".components.layouts.RegisterLayout")
@Composable
fun RegistrierungPage(ctx: PageContext) {
    var showCreateModal by remember { mutableStateOf(false) }
    val typesWithOptions = rememberQuery<List<SurveyInstallationTypeWithOptions>>(emptyList()) {
        BackendApi.get(ShopRoutes.SurveyTypesWithOptions())
    }

    Div {
        H1 { Text("Prometheus Network / Registrierung") }
        P { Text("Klicken Sie auf \"Glasfaseranschluss registrieren\" und geben Sie uns Ihre Daten bekannt, damit wir Sie auf dem Laufenden halten können. Über den Ausgang der Erhebung werden Sie von uns informiert.") }
        P { Text("Sollten nicht genug Interessenten zusammenkommen, kommt es zu keinem Ausbau mehr durch die Gemeinde bzw. Prometheus Network.") }
        P {
            Text("Mehr Infos wie es zum Bau Ihres Glasfaseranschlusses kommt finden Sie ")
            A("/assets/IchWillGlasfaser-Infobroschüre.pdf", { target(ATarget.Blank) }) {
                Text("in dieser Broschüre")
            }
            Text("!")
        }
        Button({
            onClick { showCreateModal = true }
        }) {
            Text("Glasfaseranschluss registrieren")
        }
    }

    if (showCreateModal) {
        SurveyEntryCreateModal(typesWithOptions) { showCreateModal = false }
    }
}

@Composable
private fun SurveyEntryCreateModal(
    typesWithOptions: List<SurveyInstallationTypeWithOptions>,
    onHide: () -> Unit,
) {
    Modal(onHide) {
        YaForm(
            onSubmitScope = { data ->
                val body = ShopRoutes.SurveyEntry.RequestBody(
                    name = data.string(ShopRoutes.SurveyEntry.RequestBody::name),
                    email = data.string(ShopRoutes.SurveyEntry.RequestBody::email),
                    phone = data.string(ShopRoutes.SurveyEntry.RequestBody::phone),
                    installationTypeId = data.string(ShopRoutes.SurveyEntry.RequestBody::installationTypeId),
                    installationOptionId = data.string(ShopRoutes.SurveyEntry.RequestBody::installationOptionId),
                    installationCount = data.intOrNull(ShopRoutes.SurveyEntry.RequestBody::installationCount) ?: 1,
                    installationAddressStreetName = data.string(ShopRoutes.SurveyEntry.RequestBody::installationAddressStreetName),
                    installationAddressPostalCode = data.string(ShopRoutes.SurveyEntry.RequestBody::installationAddressPostalCode),
                    installationAddressCityName = data.string(ShopRoutes.SurveyEntry.RequestBody::installationAddressCityName),
                    installationAddressCountryCode = data.string(ShopRoutes.SurveyEntry.RequestBody::installationAddressCountryCode),
                    datenverarbeitungConfirmation = data.boolean(ShopRoutes.SurveyEntry.RequestBody::datenverarbeitungConfirmation),
                    termsConfirmation = data.boolean(ShopRoutes.SurveyEntry.RequestBody::termsConfirmation),
                    privacyConfirmation = data.boolean(ShopRoutes.SurveyEntry.RequestBody::privacyConfirmation),
                    grabungsarbeitenConfirmation = data.boolean(ShopRoutes.SurveyEntry.RequestBody::grabungsarbeitenConfirmation),
                )
                BackendApi.post(ShopRoutes.SurveyEntry()) {
                    setJsonBody(body)
                }.fold(
                    onSuccess = {
                        Toasts.display(
                            Toast.success(
                                title = "Vielen Dank für Ihre Registrierung!",
                                message = "Sie erhalten in Kürze eine Bestätigungsmail.",
                            )
                        )
                        onHide()
                    },
                    onFailure = {
                        Toasts.display(
                            Toast.error(
                                title = "Fehler bei der Registrierung",
                                message = "Ein Fehler ist aufgetreten. Bitte versuchen Sie es später erneut."
                            )
                        )
                    }
                )
            }
        ) {
            val selectedType = state.data[ShopRoutes.SurveyEntry.RequestBody::installationTypeId.name]
            LaunchedEffect(selectedType) {
                if (selectedType != null) {
                    val typeWithOptions = typesWithOptions.find { it.type.id == selectedType }
                    if (typeWithOptions != null) {
                        if (typeWithOptions.options.size == 1) {
                            // If there's only one option for the selected type, select it automatically
                            state.data[ShopRoutes.SurveyEntry.RequestBody::installationOptionId.name] = typeWithOptions.options[0].id
                        } else {
                            // Clear the option selection if the type changes
                            state.data.remove(ShopRoutes.SurveyEntry.RequestBody::installationOptionId.name)
                        }
                    }
                }
            }
            Header {
                ModalCloseBtn(onHide)
                H3 { Text("Glasfaseranschluss registrieren") }
            }
            Article {
                Header { Text("1. Anschlussart wählen") }
                P { Text("Die Anschlussart ist je nach Wohnsituation unterschiedlich. Bitte wähle die Anschlussart passend zu deiner Wohnsituation aus. Der Glasfaseranschluss beinhaltet sämtliche Installationsmaterialien, welche für die Umsetzung des Anschlusses benötigt werden.") }
                YaFormDropdown(
                    prop = ShopRoutes.SurveyEntry.RequestBody::installationTypeId,
                    label = { Text("Anschlussart") },
                    options = typesWithOptions.map { it.type.id to it.type.title },
                    required = true,
                )
                selectedType?.let { typeId ->
                    val typeWithOptions = typesWithOptions.find { it.type.id == typeId }
                    if (typeWithOptions != null) {
                        YaFormDropdown(
                            prop = ShopRoutes.SurveyEntry.RequestBody::installationOptionId,
                            label = { Text("Anschlussoption") },
                            options = typeWithOptions.options.map { option ->
                                option.id to buildString {
                                    append(option.title)
                                    if (option.priceText.isNotBlank()) {
                                        append(" (${option.priceText})")
                                    }
                                }
                            },
                            required = true,
                        )
                        if (typeWithOptions.type.footnote.isNotBlank()) {
                            Small { Text(typeWithOptions.type.footnote) }
                        }
                        if (typeWithOptions.type.requiresCountInput) {
                            YaFormNumberInput(
                                prop = ShopRoutes.SurveyEntry.RequestBody::installationCount,
                                label = { Text("Anzahl der Anschlüsse") },
                                min = 1,
                                required = true,
                            )
                        }
                    }
                }
            }
            Article {
                Header { Text("2. Adresse des Anschlusses") }
                UBLPostalAddressInputs(
                    streetName = ShopRoutes.SurveyEntry.RequestBody::installationAddressStreetName,
                    postalZone = ShopRoutes.SurveyEntry.RequestBody::installationAddressPostalCode,
                    cityName = ShopRoutes.SurveyEntry.RequestBody::installationAddressCityName,
                    countryCode = ShopRoutes.SurveyEntry.RequestBody::installationAddressCountryCode,
                )
            }
            Article {
                Header { Text("3. Kontakt") }
                YaFormTextInput(
                    prop = ShopRoutes.SurveyEntry.RequestBody::name,
                    label = { Text("Name / Firma") },
                    type = InputType.Text,
                    required = true,
                )
                YaFormTextInput(
                    prop = ShopRoutes.SurveyEntry.RequestBody::email,
                    label = { Text("E-Mail") },
                    type = InputType.Email,
                    required = true,
                )
                YaFormTextInput(
                    prop = ShopRoutes.SurveyEntry.RequestBody::phone,
                    label = { Text("Telefonnummer") },
                    type = InputType.Tel,
                    required = true,
                )
            }
            Article {
                Header { Text("4. Rechtliches") }
                YaFormCheckInput(
                    prop = ShopRoutes.SurveyEntry.RequestBody::datenverarbeitungConfirmation,
                    label = {
                        Text("Ich stimme zu, dass meine Daten (Name, Anschrift, E-Mail-Adresse, Telefonnummer, Vertragsdaten) zum Zweck der telefonischen Kontaktaufnahme, sowie für die postalische und elektronische Zusendung von Produkt- und Dienstleistungs-Informationen bzw. für Marketingaktivitäten (zB Folder, Newsletter, Prospekte) an verbundene Unternehmen der Prometheus Network übermittelt werden (Gemeinde Kumberg, Glasfaser Hirt, Xinon GmbH). Diese Zustimmungserklärung kann jederzeit mittels Briefes an Prometheus Network, Klöcklstrasse 12, 8061 St. Radegund, widerrufen werden. Durch den Widerruf der Einwilligung wird die Rechtmäßigkeit der aufgrund der Einwilligung bis zum Widerruf erfolgten Verarbeitung nicht berührt.")
                    },
                    required = true,
                )
                YaFormCheckInput(
                    prop = ShopRoutes.SurveyEntry.RequestBody::termsConfirmation,
                    label = {
                        Text("Ich habe die Information über meine ")
                        Anchor("https://registrierung.meineglasfaser.info/rechtliches/ruecktrittsrecht") {
                            Text("Rücktrittsrechte")
                        }
                        Text(" als Verbraucher gemäß § 3 KSchG und §§ 11 FAGG in den ")
                        Anchor("https://prometheus-network.at/agb.pdf") {
                            Text("Allgemeinen Geschäftsbedingungen (AGB)")
                        }
                        Text(" gelesen und akzeptiere sie.")
                    },
                    required = true,
                )
                YaFormCheckInput(
                    prop = ShopRoutes.SurveyEntry.RequestBody::privacyConfirmation,
                    label = {
                        Text("Ich habe mich über die wesentlichen ")
                        Anchor("https://registrierung.meineglasfaser.info/rechtliches/vertragsbedingungen-glasfaser") {
                            Text("Vertragsinhalte")
                        }
                        Text(" sowie die Information zur Datenverarbeitung gemäß ")
                        Anchor("https://registrierung.meineglasfaser.info/rechtliches/datenschutz") {
                            Text("DSGVO")
                        }
                        Text(" informiert und akzeptiere die ")
                        Anchor("https://prometheus-network.at/agb.pdf") {
                            Text("Allgemeinen Geschäftsbedingungen")
                        }
                        Text(".")
                    },
                    required = true,
                )
                YaFormCheckInput(
                    prop = ShopRoutes.SurveyEntry.RequestBody::grabungsarbeitenConfirmation,
                    label = {
                        Text("Mit meiner Bestellung des Glasfaseranschlusses akzeptiere ich, dass Grabungsarbeiten auf meinem privaten Grund bzw. auf Privatstraßen, deren Eigentümer/Miteigentümer ich bin und nach Aufklärung durch die Planungs- bzw. der Baufirma, unerlässlich gestattet werden.")
                    },
                    required = true,
                )
            }
            ModalFooterButtons(onHide, submitLabel = "Registrieren", resetLabel = "Zurücksetzen")
        }
    }
}
